const initSentry = sentry => {
  sentry.init({
    dsn: window.SENTRY,
    release: window.RELEASE,
    integrations: [
      new sentry.Integrations.GlobalHandlers({
        onunhandledrejection: false,
      }),
    ],
    allowUrls: [
      /^https:\/\/pjrfe-75b8\.kxcdn\.com/,
      /^https:\/\/www\.prisjakt\.(nu|no){1}/,
      /^https:\/\/pricespy\.co\.(uk|nz){1}/,
      /^https:\/\/prisjagt\.dk/,
      /^https:\/\/hintaopas\.fi/,
      /^https:\/\/ledenicheur\.fr/,
    ],
  });
  return sentry;
};

const createRejectedSentryPromise = () => {
  const promise = new Promise((resolve, reject) =>
    // Make sure the promise is rejected after the .catch() handler is attached,
    // otherwise an unnecessary console error message will be logged
    requestAnimationFrame(reject)
  );
  promise.catch(() => {});
  return promise;
};

export const sentryPromise = window.SENTRY
  ? import(/* webpackChunkName: "sentry" */ '@sentry/browser').then(initSentry)
  : createRejectedSentryPromise();

// Used by sagas
export const captureException = (...args) => {
  sentryPromise
    .then(sentry => {
      sentry.captureException(...args);
    })
    .catch(() => {
      console.error(...args); // eslint-disable-line no-console
    });
};

// Used by sagas
export const captureMessage = (...args) => {
  sentryPromise
    .then(sentry => {
      sentry.captureMessage(...args);
    })
    .catch(() => {
      console.error(...args); // eslint-disable-line no-console
    });
};
